app.service('productsListView', function (sortBar, filterBar, searchResultCollector, log, autocompleteInfo, searchBox, productsListConfig, promotionListingView, callback, loading, cookie, message, searchRelatedKeywordsCarousel) {
	var $self, $products;
	var config;

	function getProductListInfo(){
		return {
			lastKeyword: config.keyword,
			searchCount: config.count,
			list: config.list,
			products: config.products
		};
	}
	function setElements(){
		$self = $("#container");
		$products= $('#products', $self);
		$item = $(".item",$products);
	}
	function setEvents() {
		$('.js-save-keyword',$products).click(function(){
			//loading.start();
			if(config.keyword){
				searchBox.saveKeyword(config.keyword);
				cookie.set('searchBack',self.location.href,{path:'/'});
			}
		});

		$('.js-log-video-button').on('click', function() {
			UA.interaction('Listing', 'Galeria', 'Film promocyjny Euro');
		});
		$('.js-more').on('click', function() {
			UA.pageInteraction('CTA', 'Standard');
		});
		$('.js-remove-filter').on('click', function() {
			var filterText = $(this).closest('.active-filter').find('.name').text().trim().replace(':', '');
			UA.interaction('Listing - Filtrowanie', 'Usuń filtrowanie', filterText);
		});

		$('.js-item-leaf').on('click', function() {
			UA.interaction('Listing - Kategorie', 'Kategoria', $(this).find('a').text().trim());
		});
		$('.js-stars').on('click', function() {
			UA.pageInteraction('Opinie', 'Opis gwiazdki');
		});
		// $('.js-instalment-link').on('click', function(event) {
		// 	loading.redirect($(this).data('href'));
		// 	event.preventDefault();
		// 	event.stopPropagation();
		// });
	}

	function suggestionTry(){
		log.event({
			id: "search_did_you_mean",
			f03: document.location.pathname + document.location.search + document.location.hash,
			f04: document.referrer,
			f05: config.suggestionTry.initialKeyword,
			f06: config.suggestionTry.suggestionKeyword,
			f07: config.suggestionTry.count,
			f08: config.suggestionTry.category==""?"wszystkie":config.suggestionTry.category
		});
		UA.interaction("Site Search", "Sugestia wyszukania", config.suggestionTry.initialKeyword+' : '+config.suggestionTry.suggestionKeyword);
	}
	function loadListingMessage(){
		var hash=document.location.hash;
		if (hash.match(/^#fromProduct-/)) {
			var table = hash.replace(/#fromProduct-/,"").replace(/%7C/gi, "|").split('|').map((item, i) => {
				return decodeURIComponent(item).replace(/<[^>]*>/gi, "");
			});
			var hashQuery={
				product:table[0]
			};

			message.get({
				code:'redirect_from_inactive_or_archival_product',
				names: ['product_name','products_group'],
				values: [hashQuery.product, config.name]
			}).then(function(html){
				$('#from-product').html(html).addClass('showed');
			});
		} else if (hash.match(/^#fromPartnerSubscription-/)) {
			var table = hash.replace(/#fromPartnerSubscription-/,"").replace(/%7C/gi, "|").split('|').map((item, i) => {
				return decodeURIComponent(item).replace(/<[^>]*>/gi, "");
			});
			var hashQuery={
				product:table[0]
			};

			message.get({
				code:'redirect_from_partner_subscription',
				names: ['product_name','products_group'],
				values: [hashQuery.product, config.name]
			}).then(function(html){
				$('#from-product').html(html).addClass('showed');
			});
		}
	}
	function init() {
		setElements();
		setEvents();
		config=productsListConfig.getData();
		loadListingMessage();
		searchResultCollector.init('list',{
			keyword	: config.keyword,
			nodeId	: config.nodeId,
			searchType: '',
			resultNumber : config.count
		});
		if(config.keyword){
			searchBox.setKeyword(config.keyword);
		}
		log.visit({
			nodeName:config.nodeId,
			keyword:config.keyword || undefined
		}, function(){
			if(config.suggestionTry){
				suggestionTry();
			}
		});
		filterBar.init();
		sortBar.init();
		cookie.set('refgroup',self.location.pathname);
		callback.run('getProductListInfo', getProductListInfo());
		promotionListingView.init();

		if (config.keyword && config.keyword.length) { // jeżeli jesteśmy na stronie wyników wyszukiwania
			searchRelatedKeywordsCarousel.init();
		}
	}
	return {
		init:init
	};
});
